"use client";

import { FC } from "react";
import { SessionRecorder } from "components/molecules/SessionRecorder";
import { SessionDTO } from "types";
import * as Styled from "./SessionCompanionLanding.styled";
interface SessionCompanionLandingProps {
  session?: SessionDTO;
}
export const SessionCompanionLanding: FC<SessionCompanionLandingProps> = ({
  session
}) => {
  return <Styled.Main suppressHydrationWarning data-sentry-element="unknown" data-sentry-component="SessionCompanionLanding" data-sentry-source-file="index.tsx">
            <Styled.Title data-sentry-element="unknown" data-sentry-source-file="index.tsx">Session Companion</Styled.Title>
            <Styled.SubTitle data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                Record your session and generate images for it in real-time.
            </Styled.SubTitle>
            <SessionRecorder session={session} data-sentry-element="SessionRecorder" data-sentry-source-file="index.tsx" />
        </Styled.Main>;
};